<template>
  <div :class="Loading ? 'disable' : ''">
    <fieldset class="border rounded mt-2 p-2">
      <legend>Master Unit Role</legend>
      <div>
        <template v-for="(client, i) in clientUserRolesData">
          <div
            class="mb-2 mt-3"
            style="display: grid; grid-gap: 1rem; grid-template-columns: 1fr 1fr 1fr; align-items: center;"
            v-if="client.is_master_client"
            :key="client.id"
          >
            <label class="text-right pr-2 m-0">
              {{ client.name }}
            </label>
            <b-select
              v-model="client.client_role_id"
              @change="setDescription(i, client.client_role_id)"
            >
              <option :value="0">None</option>
              <option
                v-for="role in client.client_roles"
                :key="role.clientRoleId"
                :value="role.clientRoleId"
                >{{ role.clientRoleName }}</option
              >
            </b-select>
            <p class="m-0">{{ roleDescription }}</p>
          </div>
          <div
            :key="i"
            v-if="
              client.is_master_client &&
                client.client_role_id !== 0 &&
                client.client_role_id !== client.participant_role_id
            "
          >
            <div class="mb-1" style="margin: 0 35%;">
              <span
                class="pr-1"
                style="color: blue; cursor: pointer;"
                @click="checkAll(client)"
                >Check All</span
              >|<span
                class="pl-1"
                style="color: blue; cursor: pointer;"
                @click="uncheckAll(client)"
                >Uncheck All</span
              >
            </div>
            <div
              v-for="(unit, j) in clientUserRolesData"
              :key="j"
              style="margin: 0 35%;"
            >
              <input
                type="checkbox"
                name=""
                id=""
                class="mr-1"
                :value="unit.id"
                v-model="client.client_user_units"
              />
              <span style="font-size: 1rem;">{{ unit.name }}</span>
            </div>
          </div>
        </template>
        <p class="mt-2">
          * Selecting this role will overwrite permissions for existing roles at
          low level units
        </p>
      </div>
    </fieldset>

    <fieldset class="border rounded mt-2 p-2 mb-3">
      <legend>Business Units Roles</legend>
      <div style="display: grid; grid-template-columns: 1fr 1fr;">
        <template v-for="client in clientUserRolesData">
          <div :key="client.id" v-if="!client.is_master_client">
            <div
              class="d-flex mb-2 mt-3"
              v-if="!client.is_master_client"
              style="align-items: center;"
            >
              <label style="width: 50%; margin: 0;" class=" text-right pr-2">
                {{ client.name }}
                <p class="mb-0" v-if="client.id === defaultId">(Default)</p>
              </label>
              <b-select v-model="client.client_role_id">
                <option :value="0">None</option>
                <option
                  v-for="role in client.client_roles"
                  :key="role.clientRoleId"
                  :value="role.clientRoleId"
                  >{{ role.clientRoleName }}</option
                >
              </b-select>
            </div>
            <div
              v-if="
                client.client_role_id !== 0 &&
                  client.client_role_id !== client.participant_role_id
              "
            >
              <div class="mb-1" style="margin: 0 0 0 35%;">
                <span
                  class="pr-1"
                  style="color: blue; cursor: pointer;"
                  @click="checkAll(client)"
                  >Check All</span
                >|<span
                  class="pl-1"
                  style="color: blue; cursor: pointer;"
                  @click="uncheckAll(client)"
                  >Uncheck All</span
                >
              </div>
              <div
                v-for="(unit, j) in clientUserRolesData"
                :key="j"
                style="margin: 0 0 0 35%;"
              >
                <input
                  type="checkbox"
                  name=""
                  id=""
                  class="mr-1"
                  :value="unit.id"
                  v-model="client.client_user_units"
                />
                <span style="font-size: 1rem;">{{ unit.name }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </fieldset>

    <div class="d-flex" style="justify-content: center;">
      <button type="button" class="btn btn-primary" @click="save('')">
        Save
      </button>
      <button
        type="button"
        class="ml-2 mr-2 btn btn-primary"
        @click="save('ret')"
      >
        Save and Return
      </button>
      <button
        type="button"
        style="color: white;"
        class="btn btn-danger"
        @click="cancel"
      >
        Cancel
      </button>
    </div>

    <div v-if="Loading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RolesByUnit",
  data() {
    return {
      Loading: false,
      completeClientList: [],
      defaultId: this.$route.query.company_id,
      roleDescription: "",
    };
  },
  computed: {
    logged_in_user_data() {
      return this.$store.state.user.profile;
    },
    client_id() {
      return this.$store.state.user.userClients.client;
    },
    clientUserRolesOldData() {
      return this.$store.state.settings.clientUserRolesOldData;
    },
    clientUserRolesData() {
      return this.$store.state.settings.clientUserRolesData;
    },
  },
  methods: {
    save(ret) {
      try {
        const payload = {
          logged_in_user_id: this.logged_in_user_data.id,
          logged_in_user_name: this.logged_in_user_data.username,
          user_id: Number(this.$route.query.Id),
          user_name: decodeURI(this.$route.query.user_name) || "",
          client_user_role_updates: [],
        };

        for (let i = 0; i < this.clientUserRolesData.length; i++) {
          const storeObj = this.clientUserRolesData[i];

          const payloadObj = {
            client_id: storeObj.id,
            client_name: storeObj.name,
            previous_client_role_id: storeObj.client_role_id_old,
            previous_client_role_name: storeObj.client_role_name_old,
            new_client_role_id: storeObj.client_role_id,
            new_client_role_name: storeObj.client_role_name,
            unit_client_ids: storeObj.client_user_units,
          };

          if (payloadObj.new_client_role_id !== 0) {
            const roleSelected = storeObj.client_roles.filter((role) => {
              if (payloadObj.new_client_role_id === role.clientRoleId) {
                return role;
              }
            });
            payloadObj.new_client_role_name = roleSelected[0].clientRoleName;

            // for handling Participant ->
            // unit_client_ids is empty
            if (payloadObj.new_client_role_name === "Participant") {
              payloadObj.unit_client_ids = [];
            }
          }
          // for handling None ->
          // 1. new_client_role_name is empty
          // 2. unit_client_ids is empty
          else {
            payloadObj.new_client_role_name = "";
            payloadObj.unit_client_ids = [];
          }

          if (
            payloadObj.previous_client_role_id === 0 &&
            payloadObj.new_client_role_id === 0
          ) {
          } else {
            payload.client_user_role_updates.push(payloadObj);
          }
        }

        console.log(payload);

        this.$store
          .dispatch("settings/updateClientUserUnit", payload)
          .then(() => {
            if (ret === "ret") {
              this.$router.push({
                name: "AdminSettingsRoleAndPermissionsManageRoles",
              });
            }
          })
          .catch((err) => {
            alert(err.data.message);
          });
      } catch (err) {
        alert(err);
      }
    },
    cancel() {
      this.$router.push({
        name: "AdminSettingsRoleAndPermissionsManageRoles",
      });
    },
    checkAll(Client) {
      const selectedClient = this.clientUserRolesData.filter(
        (client) => client.id === Client.id
      );
      selectedClient[0].client_user_units = this.completeClientList;
    },
    uncheckAll(Client) {
      const selectedClient = this.clientUserRolesData.filter(
        (client) => client.id === Client.id
      );
      selectedClient[0].client_user_units = [];
    },
    setDescription(i, roleID) {
      if (roleID === 0) {
        this.roleDescription = "";
        return;
      }
      let roleSelected = this.clientUserRolesData[i].client_roles.filter(
        (client_role) => client_role.clientRoleId === roleID
      );
      this.roleDescription = roleSelected[0].role_description;
    },
  },
  created() {
    this.Loading = true;
    this.$store
      .dispatch("settings/getClientUserRoles", {
        userId: this.$route.query.Id,
        clientId: this.$route.query.company_id,
      })
      .then((data) => {
        console.log(data);
        this.completeClientList = data.map((client) => client.id);
        this.Loading = false;
      });
  },
};
</script>

<style scoped>
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
